import React,{useEffect} from "react";
import { Col, Container, Row, Button } from "reactstrap";
import { RiFacebookCircleFill, RiInstagramLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLabelsName, } from "../actions/lableAction";

const Footer = (props) => {
  const { frontLabelsName } = props.label;
  const{getLabelsName}=props
  const { isAuthenticated, loading } = props.auth;
  useEffect(()=>{
    if(!frontLabelsName || frontLabelsName.length === 0){
      getLabelsName()    }
   },[frontLabelsName])

  return (
    <footer className="footer-bottom1">
      <div className="footer-container container-fluid">
        <div className=" row footer-row">
          <div className=" col-lg-3 col-md-12 footer-col px-xl-5 px-lg-3  px-0">
            <div className="footer-logo">
              <img src={"assets/footer-logo.svg"} alt="" />
            </div>
            <label className="footer-label">
              {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_find_beautiful_home")
                  .length > 0
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_find_beautiful_home"
                  )[0]["value"] || "lbl_find_beautiful_home"
                  : "lbl_find_beautiful_home"
                : "lbl_find_beautiful_home"}
            </label>
            <div>
              <Link to="/registration/type">
                <Button className="join-button ">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_join_now").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_join_now")[0][
                      "value"
                      ] || "lbl_join_now"
                      : "lbl_join_now"
                    : "lbl_join_now"}
                </Button>
              </Link>
            </div>
          </div>
          <div className="col-lg-9 col-md-12">
            <div className="row footer-first-row cursor-style">
              <div className="col-lg-3 col-md-6 col-xs-12 footer-list px-0">
                <span className="the-rental-list">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rental_list")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_rental_list")[0][
                      "value"
                      ] || "lbl_rental_list"
                      : "lbl_rental_list"
                    : "lbl_rental_list"}
                </span>
                <ul>
                  <li className="the-company">
                    <Link to="/the-company">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_company")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_company")[0][
                          "value"
                          ] || "lbl_company"
                          : "lbl_company"
                        : "lbl_company"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/staff">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_staff")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_staff")[0][
                          "value"
                          ] || "lbl_staff"
                          : "lbl_staff"
                        : "lbl_staff"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/price-list">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_price_list")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_price_list"
                          )[0]["value"] || "lbl_price_list"
                          : "lbl_price_list"
                        : "lbl_price_list"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/location-opening-hours">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_location_opening_hour"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_location_opening_hour"
                          )[0]["value"] || "lbl_location_opening_hour"
                          : "lbl_location_opening_hour"
                        : "lbl_location_opening_hour"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/privacy-policy">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_privacy_policy"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_privacy_policy"
                          )[0]["value"] || "lbl_privacy_policy"
                          : "lbl_privacy_policy"
                        : "lbl_privacy_policy"}
                    </Link>
                  </li>
                   <li className="the-company">
                    <Link to="/terms-and-conditions">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_terms_and_conditions"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_terms_and_conditions"
                          )[0]["value"] || "lbl_terms_and_conditions"
                          : "lbl_terms_and_conditions"
                        : "lbl_terms_and_conditions"}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-xs-12 footer-list px-0">
                <span className="the-rental-list">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_tenants").length >
                      0
                      ? frontLabelsName.filter((e) => e.key == "lbl_tenants")[0][
                      "value"
                      ] || "lbl_tenants"
                      : "lbl_tenants"
                    : "lbl_tenants"}
                </span>
                <ul>
                  <li className="the-company">
                    <Link to="/access-by-otp">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_register_me_tenant"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_me_tenant"
                          )[0]["value"] || "lbl_register_me_tenant"
                          : "lbl_register_me_tenant"
                        : "lbl_register_me_tenant"}
                    </Link>
                  </li>

                  <li className="the-company">
                    <Link to="/registration/find-property">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_find_apartment_rent"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_find_apartment_rent"
                          )[0]["value"] || "lbl_find_apartment_rent"
                          : "lbl_find_apartment_rent"
                        : "lbl_find_apartment_rent"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/tenant-service">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_tenant_service"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_tenant_service"
                          )[0]["value"] || "lbl_tenant_service"
                          : "lbl_tenant_service"
                        : "lbl_tenant_service"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/housing-benefit">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_housing_benefit"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_housing_benefit"
                          )[0]["value"] || "lbl_housing_benefit"
                          : "lbl_housing_benefit"
                        : "lbl_housing_benefit"}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-xs-12 footer-list px-0">
                <span className="the-rental-list">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_landlords")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_landlords")[0][
                      "value"
                      ] || "lbl_landlords"
                      : "lbl_landlords"
                    : "lbl_landlords"}
                </span>
                <ul>
                  <li className="the-company">
                    <Link to="/landlords/register-property-free" 
                    onClick={() => localStorage.setItem("register_Property", 1)}
                    >
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_register_property_free"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_property_free"
                          )[0]["value"] || "lbl_register_property_free"
                          : "lbl_register_property_free"
                        : "lbl_register_property_free"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/landlords/register-property-free" 
                    onClick={() => localStorage.setItem("register_Property", 2)}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_find_tenant")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_find_tenant"
                          )[0]["value"] || "lbl_find_tenant"
                          : "lbl_find_tenant"
                        : "lbl_find_tenant"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/landlords/register-property-free" 
                    onClick={() => localStorage.setItem("register_Property", 3)}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_register_property_agency"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_property_agency"
                          )[0]["value"] || "lbl_register_property_agency"
                          : "lbl_register_property_agency"
                        : "lbl_register_property_agency"}
                    </Link>
                  </li>
                  <li className="the-company">
                    <Link to="/landlord-service-available">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_landlord_service"
                        ).length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_landlord_service"
                          )[0]["value"] || "lbl_landlord_service"
                          : "lbl_landlord_service"
                        : "lbl_landlord_service"}
                    </Link>
                  </li>
                 
                </ul>
               
              </div>
              <div className="col-lg-3 col-md-6 col-xs-12 px-0">
                <div className="footer-list ">
                  <span className="the-rental-list">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_assistance")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_assistance"
                        )[0]["value"] || "lbl_assistance"
                        : "lbl_assistance"
                      : "lbl_assistance"}
                  </span>
                  <ul>
                    <li className="the-company d-flex align-items-center telephon-size">
                      <img
                        src="assets/icons/telephone.svg"
                        className="telephone-svg"
                      />
                      <Link to="/">511-1600</Link>
                    </li>
                    <li className="the-company">
                      <Link to="/question-answer">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_question_answer"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_question_answer"
                            )[0]["value"] || "lbl_question_answer"
                            : "lbl_question_answer"
                          : "lbl_question_answer"}
                      </Link>
                    </li>
                    <li className="the-company">
                     <Link to="/links">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_help_links"
                          ).length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_help_links"
                            )[0]["value"] || "lbl_help_links"
                            : "lbl_help_links"
                          : "lbl_help_links"}
                      </Link>
                    </li>
                    <li className="the-company">
                      <Link to="/contact-us">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_contact_us")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_contact_us"
                            )[0]["value"] || "lbl_contact_us"
                            : "lbl_contact_us"
                          : "lbl_contact_us"}
                      </Link>
                    </li>
                    {!loading && !isAuthenticated && (
                      <li className="the-company">
                        <Link to="/forget-password">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_forgotten_password"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_forgotten_password"
                              )[0]["value"] || "lbl_forgotten_password"
                              : "lbl_forgotten_password"
                            : "lbl_forgotten_password"}
                        </Link>
                      </li>
                    )}
                    <li className="the-company">
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <RiFacebookCircleFill />
                      </a>
                      <a
                        href="https://www.instagram.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="ms-1"
                      >
                        <RiInstagramLine />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="footer-bottom-row ">
        <Col sm="12" className="footer-bottom-col">
          <label className="footer-bottom-text">
            {/* Leigulistinn ehf. © 2021 All rights reserved - ID number: 7112983209 - VAT no: 60767 */}
            {frontLabelsName
              ? frontLabelsName.filter((e) => e.key == "lbl_footer").length > 0
                ? frontLabelsName.filter((e) => e.key == "lbl_footer")[0]["value"] ||
                "lbl_footer"
                : "lbl_footer"
              : "lbl_footer"}
          </label>
        </Col>
      </Row>
    </footer>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});
export default connect(mapStateToProps, {getLabelsName})(Footer);
